import store from 'store';
import RA from 'actions/dod/dodReviewActions';

export function dodReviewToggleModal(resetRequest) {
    resetRequest = !!resetRequest;
    store.dispatch({ type: RA.DOD_REVIEW_TOGGLE_SUBMISSION_MODAL, payload: resetRequest });
}
